module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/monitor-pc/power.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/monitor-pc/power.jpg
// module id = 593
// module chunks = 0